'use client';

import type { ReactNode } from 'react';
import dynamic from 'next/dynamic';
import { SiteChrome } from 'app/site-chrome';
import { Cart } from 'components/shared/Cart';
import { usePartnerPolicy } from 'contexts/PartnerModeContext';
import styles from './partner-chrome.module.css';

// Split out so non-Optum pages ship none of the Optum chrome.
const OptumHeader = dynamic(() =>
  import('components/optum/OptumHeader').then((m) => m.OptumHeader),
);
const OptumFooter = dynamic(() =>
  import('components/optum/OptumFooter').then((m) => m.OptumFooter),
);

/** Picks the chrome from the URL on every render, so leaving `?flow=optum` restores the site chrome. */
export function PartnerChrome({
  children,
  siteFooter,
}: {
  children: ReactNode;
  siteFooter: ReactNode;
}) {
  if (usePartnerPolicy().chrome === 'optum') {
    return (
      <div className={styles.optumChrome}>
        <OptumHeader />
        {children}
        <Cart />
        <OptumFooter />
      </div>
    );
  }
  return <SiteChrome footer={siteFooter}>{children}</SiteChrome>;
}
